@if (loading) {
  <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 5 }"></nz-skeleton>
} @else {
  @if(this.ps.selectedProject?.projectContainers!.length > 0) {
    <div class="flex flex-column gap-200">

      <!-- Filter Cards -->
      <div hidden class="flex gap-200">
        @for (card of cardsFilters; track card.label) {
          <nz-card nzHoverable [class.active]="card.active" (click)="cardFilter(card.label!)">
        <span class="text-label-14">
          {{ card.label === 'Contenedores' ? this.ps.selectedProject?.projectContainers!.length : (card.label === 'Contenedores usados' ? totalUsedContainers : totalFreeContainers) }}
        </span>
            <span class="text-label-14"> {{ card.label }}</span>
          </nz-card>
        }
      </div>

      <!--    <a (click)="openServiceOrderInNewTab(39, 49, 20)">-->
      <!--      <app-st-icon class="cursor-pointer" style="font-size: 14px"-->
      <!--                   [bold]="true" [name]="'open_in_new'" [color]="'#666666'"></app-st-icon>-->
      <!--    </a>-->

      <!--  Container de filtros y botones   -->
      <div class="flex flex-center-between">
        <!--  Container de Buscador y filtros generales   -->
        <div class="flex-center gap-150">
          <!--   Buscador   -->
          <app-pocket-searchbar style="width: 100%"
                                [(searchValue)]="searchValue"
                                (searchEvent)="filter()"></app-pocket-searchbar>

          <!--   Búsqueda avanzada contenedores   -->
          <div (click)="openContainerAdvancedSearchDrawer()"
               class="st-badget"
               [ngClass]="hasAdvancedContainerFilterApplied ? 'black' : 'subtle-grey'">
            <app-st-icon class="prefix" [name]="'calendar_view_week'"></app-st-icon>
            <label>Contenedores</label>
          </div>
          <!--   Filters   -->
          <div class="flex-center-between gap-150 no-scroll-bar" style="min-width: fit-content;">
            @for (filtro of generalFilters; let first = $first; track filtro.name) {
              <div class="st-badget"
                   [nzDropdownMenu]="filtro.name === 'Tipo'
                                  ? containerTypeMenu : null"
                   nz-dropdown [nzTrigger]="'click'"
                   [ngClass]="filtro.active ? (filtro.class || 'black') : 'subtle-grey'">
                <label>{{ filtro.name }}</label>
                <app-st-icon [name]="filtro.icon"></app-st-icon>
              </div>

              <!-- Menú desplegable para containerTypes -->
              <nz-dropdown-menu #containerTypeMenu="nzDropdownMenu">
                <ul nz-menu>
                  @for (type of containerTypeAvailable; track type.id) {
                    <li nz-menu-item [class.bg-grey-1]="type.id === containerTypeFilterValue?.id"
                        (click)="onFilterSelect(filtro.name, type)">
                      {{ type.description }}
                    </li>
                  }
                </ul>
              </nz-dropdown-menu>

              <!-- Menú desplegable para Services -->
              <nz-dropdown-menu #servicesMenu="nzDropdownMenu">
                <ul nz-menu>
                  @for (service of serviceList; track service.id) {
                    <li nz-menu-item [class.bg-grey-1]="service.id === serviceFilterValue?.id"
                        (click)="onFilterSelect(filtro.name, service)">
                      {{ service.name }}
                      <app-service-flow-warning [hasFlow]="service.hasFlow"></app-service-flow-warning>
                    </li>
                  }
                </ul>
              </nz-dropdown-menu>

              <!-- Menú desplegable para ServicesOrders -->
<!--              <nz-dropdown-menu #servicesOrdersMenu="nzDropdownMenu">-->
<!--                <ul nz-menu>-->
<!--                  @for (serviceOrder of serviceOrderList; track serviceOrder.id) {-->
<!--                    <li nz-menu-item [class.bg-grey-1]="serviceOrder.id === serviceOrderFilterValue?.id"-->
<!--                        (click)="onFilterSelect(filtro.name, serviceOrder)">-->
<!--                      {{ serviceOrder.reference }}-->
<!--                    </li>-->
<!--                  }-->
<!--                </ul>-->
<!--              </nz-dropdown-menu>-->
            }
          </div>
        </div>


        <!--  Container de btns de accion   -->
        <div class="flex gap-150">
          @if (selectedContainerIds.size > 0 && !!authService.loggedUser$.value?.generateOrders) {
            <button hidden
                    (click)="openContainerCreateDrawer(false)"
                    nz-button nzSize="default" nzShape="round" nzType="default" class="text-btn-14">
              Crear órdenes
            </button>
          }

          @if (!!authService.loggedUser$.value?.createContainers) {
            <button
                    (click)="openContainerCreateDrawer(true)"
                    class="flex-center gap-075" nzSize="default" nz-button
                    [nzShape]="(screenService.isMobile$ | async) ? 'circle' : 'round'"
                    [nzType]="(screenService.isMobile$ | async) ? 'default' : 'primary'">
              <app-st-icon [class.prefix]="!(screenService.isMobile$ | async)" class="text-btn-14 flex-center"
                           [bold]="true" name="add"></app-st-icon>
              @if (!(screenService.isMobile$ | async)) {
                <span class="text-btn-14">Añadir</span>
              }
            </button>
          }
        </div>
      </div>

      <nz-table #containerTbl [nzData]="filteredContainers" [nzScroll]="{x: 'auto'}" class="st-bordered"
                [nzTotal]="filteredContainers.length"
                [nzPageIndex]="pageIndex"
                [nzPageSize]="pageSize"
                [nzPageSizeOptions]="pageSizeOptions"
                nzShowSizeChanger
                (nzPageIndexChange)="onPageIndexChange($event)"
                (nzPageSizeChange)="onPageSizeChange($event)">
        <tr>
          @for (column of columns; track column) {
            @if (!column.checkbox) {
              <th [nzAlign]="column.align || null" style="white-space: nowrap"
                  [style.min-width]="column.name === 'Documentación' ? 'max-content' : undefined"
                  [class.sorteable-column]="column.sortable"
                  [style.width]="column.width ? (column.width + 'px') : 'auto'">
                {{ column.name }}

                @if (column.sortable) {
   <app-st-th-sort
                  [sortDirection]="getColumnSortDirection(column)"
                  (sortEvent)="column.sortFn && column.sortFn()"></app-st-th-sort>
                }
              </th>
            }
<!--            <th *ngIf="column.checkbox" nzAlign="center"-->
<!--                [style.width]="column.width ? (column.width + 'px') : 'auto'">-->
<!--              <label nz-checkbox [nzIndeterminate]="isIndeterminate"-->
<!--                     (nzCheckedChange)="toggleSelectAllContainer()"-->
<!--                     [nzChecked]="isAllSelected"></label>-->
<!--            </th>-->
          }
          <th style="width: 76px" [nzRight]="(screenService.isMobile$ | async) ? false : '0px'"></th>
        </tr>
        <tbody>
          @for (container of containerTbl.data; track container) {
            <tr>
<!--              <td nzAlign="center">-->
<!--                <label nz-checkbox (nzCheckedChange)="toggleSelectContainer(container.id)" class="top-0"-->
<!--                       [nzChecked]="selectedContainerIds.has(container.id)"></label>-->
<!--              </td>-->

              <td [class.color-grey-9]="!container.containerRef">{{ container.containerRef || '-' }}</td>

              <td [class.color-grey-9]="!container.containerType?.description">{{ container.containerType?.description || '-' }}</td>

<!--              <td>-->
<!--                @if (container.service) {-->
<!--                  <div class="flex-center">-->
<!--                    <span>{{ container.service.name }}</span>-->
<!--                    <a [routerLink]="['/project/detail/', ps.selectedProject!.id, 'service', container.service.id]"-->
<!--                       target="_blank">-->
<!--                      <app-st-icon class="cursor-pointer" style="font-size: 14px"-->
<!--                                   [bold]="true" [name]="'open_in_new'" [color]="'#666666'"></app-st-icon>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                } @else {-->
<!--                  - -->
<!--                }-->
<!--              </td>-->

<!--              <td>-->
<!--                @if (container.serviceOrder) {-->
<!--                  <div class="flex-center">-->
<!--                    <span>{{ container.serviceOrder.reference }}</span>-->
<!--                    <a-->
<!--                      (click)="openServiceOrderInNewTab(ps.selectedProject!.id, container.serviceOrder.serviceId!, container.serviceOrder.id)"-->
<!--                    >-->
<!--                      <app-st-icon class="cursor-pointer" style="font-size: 14px"-->
<!--                                   [bold]="true" [name]="'open_in_new'" [color]="'#666666'"></app-st-icon>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                } @else {-->
<!--                  - -->
<!--                }-->
<!--              </td>-->

              <td nzAlign="center" class="action-cell" [nzRight]="(screenService.isMobile$ | async) ? false : '0px'">
                <button (click)="openContainerDetailDrawer(container, true)" nz-button nzType="text" nzShape="circle"
                        nzSize="default">
                  <app-st-icon name="right_panel_open" [bold]="true"></app-st-icon>
                </button>
                @if (!!authService.loggedUser$.value?.createContainers) {
                  <button
                          nz-button nzType="text" nzShape="circle" nzSize="default" nz-dropdown
                          [nzDropdownMenu]="actionMenu" nzTrigger="click">
                    <app-st-icon name="more_vert" [bold]="true"></app-st-icon>
                  </button>
                }
              </td>

              <nz-dropdown-menu #actionMenu="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item (click)="openContainerDetailDrawer(container, false)">
                    <button class="flex-center gap-100"
                            nz-button nzType="text" nzShape="circle" nzSize="default">
                      <app-st-icon name="edit" [bold]="true"></app-st-icon>
                      <span class="text-label-14 text-dark">Editar</span>
                    </button>
                  </li>
                  <li nz-menu-item (click)="openDeleteConfirmation(container.id)">
                    <button class="flex-center gap-100"
                            nz-button nzType="text" nzShape="circle" nzSize="default">
                      <app-st-icon name="delete" [bold]="true"></app-st-icon>
                      <span class="text-label-14 text-dark">Eliminar</span>
                    </button>
                  </li>
                </ul>
              </nz-dropdown-menu>
            </tr>
          }
        </tbody>
      </nz-table>

      @if (!filteredContainers.length) {
        <nz-empty nzNotFoundImage="simple"></nz-empty>
      }
    </div>
  } @else {
    <app-empty-state (btnPressEvent)="openContainerCreateDrawer(true)"
                     [icon]="'calendar_view_week'"
                     [paddingTop]="'50px'" [height]="'100%'"
                     [hideBtn]="!this.authService.loggedUser$.value?.editProject && !authService.loggedUser$.value?.createContainers"
                     [object]="'contenedores'" [btnIcon]="'add'" [btnText]="'Añadir contenedor'"></app-empty-state>
  }
}


<ng-template #notificationTmpl>
  @if (notRef) {
<app-toast [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor"
    [showUndo]="toastConfig.showUndo"
    [notRef]="notRef" [content]="toastConfig.content" [msg]="toastConfig.msg"></app-toast>
  }
</ng-template>

<app-confirmation-modal #confirmationModal (confirmed)="onDeleteConfirmed($event)"></app-confirmation-modal>

<ng-template #applyModeModalTitleTmpl>
  <div class="text-label-16 text-semibold">Aplicar resultados encontrados</div>
</ng-template>

<ng-template #applyModeModalContentTmpl>
  <div style="padding: 12px 24px;" class="text-label-14 color-grey-8 flex flex-column gap-100">
    <span><strong>Combinar</strong> mantiene los filtros actuales y agrega los contenedores encontrados.</span>
    <span><strong>Reemplazar</strong> limpia el texto de búsqueda y aplica solo los contenedores encontrados.</span>
    <span class="text-dark">¿Qué deseas hacer?</span>
  </div>
</ng-template>

<ng-template #applyModeModalFooterTmpl>
  <div class="flex-center-between">
    <button nz-button nzShape="round" nzSize="default" class="text-btn-14" nzType="default" (click)="onApplyModeAction('cancel')">
      Cancelar
    </button>
    <div class="flex-center gap-100">
      <button nz-button nzShape="round" nzSize="default" class="text-btn-14" nzType="default" (click)="onApplyModeAction('replace')">
        Reemplazar
      </button>
      <button nz-button nzShape="round" nzSize="default" class="text-btn-14" nzType="primary" (click)="onApplyModeAction('combine')">
        Combinar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #clearModalTitleTmpl>
  <div class="text-label-16 text-semibold">Limpiar búsqueda avanzada</div>
</ng-template>

<ng-template #clearModalContentTmpl>
  <div style="padding: 12px 24px;" class="text-label-14 color-grey-8 flex flex-column gap-100">
    <span>Se eliminará el filtro aplicado desde búsqueda avanzada de contenedores. ¿Deseas continuar?</span>
  </div>
</ng-template>

<ng-template #clearModalFooterTmpl>
  <div class="flex-center-between">
    <button nz-button nzShape="round" nzSize="default" class="text-btn-14" nzType="default" (click)="onClearModalAction('cancel')">
      Cancelar
    </button>
    <button nz-button nzShape="round" nzSize="default" class="text-btn-14" nzType="primary" (click)="onClearModalAction('limpiar')">
      Limpiar
    </button>
  </div>
</ng-template>
